import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section
      className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden"
      aria-label="首页首屏"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20composition%20with%20flowing%20warm%20red%20gold%20and%20deep%20blue%20color%20bands%2C%20motion%20blur%20effect%2C%20fashion%20magazine%20editorial%20style%2C%20luxurious%20and%20dramatic%20atmosphere%2C%20high%20contrast%2C%20soft%20glow%2C%20professional%20photography%2C%20clean%20minimal%20lower%20area%20with%20cream%20and%20beige%20tones%2C%20sophisticated%20mood&width=1800&height=900&seq=hero-main-bg-001&orientation=landscape"
        alt="91免费 - 每日吃瓜黑料在线追踪"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full flex flex-col items-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-sans text-background-50 leading-tight tracking-tight max-w-4xl">
          每日吃瓜黑料
        </h1>
        <p className="mt-3 md:mt-4 text-xl md:text-3xl lg:text-4xl font-heading italic text-background-50/90">
          实时追踪更新
        </p>
        <p className="mt-4 md:mt-6 text-sm md:text-base text-background-50/70 font-light max-w-xl">
          覆盖明星八卦、网红爆料、热门事件，一站式娱乐资讯平台，让你永远站在吃瓜第一线
        </p>
        <Link
          to="/category/daily-update"
          className="mt-8 md:mt-10 inline-flex items-center gap-2 px-10 py-3.5 bg-background-50 text-foreground-950 text-sm md:text-base font-semibold rounded-full transition-all duration-300 hover:bg-background-50/90 hover:scale-105 cursor-pointer whitespace-nowrap"
        >
          立即吃瓜
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}